import React from "react";

import { Grid } from "semantic-ui-react";

// custom input components
import AmountAndPaidInput from "../AmountAndPaidInput";
import QuantityInput from "../QuantityInput";
import RateInput from "../RateInput";

function RateAndQuantity({ currency = "Rs.", quantityOnly, forSale, ...rest }) {
	if (quantityOnly)
		return (
			<Grid style={{ marginTop: "0px", marginBottom: "0px" }}>
				<Grid.Column width={16}>
					<QuantityInput />
				</Grid.Column>
			</Grid>
		);
	return (
		<>
			<Grid
				columns={3}
				style={{
					marginTop: "0px",
					marginBottom: "0px",
				}}
			>
				<Grid.Column>
					<QuantityInput forSale={forSale} />
				</Grid.Column>
				<Grid.Column>
					<RateInput forSale={forSale} />
				</Grid.Column>
				<Grid.Column>
					<AmountAndPaidInput currency={currency} />
				</Grid.Column>
			</Grid>
		</>
	);
}

export default RateAndQuantity;
